import React from 'react';
import { ZapIcon } from 'lucide-react';
export function StickyBar() {
  return <div className="sticky top-0 z-40 w-full bg-gold text-navy" data-id="element-183" data-mp="12lqvs3f1mb14">
      <div className="mx-auto flex max-w-page items-center justify-center gap-2 px-4 py-2 text-center" data-id="element-184" data-mp="12mac5fp1ord1">
        <ZapIcon className="h-3.5 w-3.5 shrink-0 sm:h-4 sm:w-4" aria-hidden="true" strokeWidth={2.5} data-id="element-185" data-mp="xspc7i3w5nb7" />
        <p className="font-display text-[10px] font-bold uppercase leading-snug tracking-[0.08em] sm:text-xs sm:tracking-[0.12em]" data-id="element-186" data-mp="stl2mqd21nkc">
          <span className="sm:hidden" data-id="element-187" data-mp="juhmnv96poa2">Launch pricing ends today · save 96%</span>
          <span className="hidden sm:inline" data-id="element-188" data-mp="evwm1uq0t2l3">
            Limited time: launch pricing ends today. Save 96% on the complete Blues Instructor
            System.
          </span>
        </p>
      </div>
    </div>;
}